import { render, staticRenderFns } from "./TheNotificationList.vue?vue&type=template&id=a3ca694a&scoped=true"
import script from "./TheNotificationList.vue?vue&type=script&lang=js"
export * from "./TheNotificationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ca694a",
  null
  
)

export default component.exports